
import './App.css';



import React from 'react';


import AllRoutes from './Pages/AllRoutes';


function App() {
  return (
    <div className="App">
      
    <AllRoutes/>
    
    </div>
  );
}


export default App;


